import type { FC, PropsWithChildren } from "react";

import { PageContentSkeleton } from "src/components/loading";
import { useResourcePermission } from "src/components/permission/use-resource-permission";
import { Navigate, useParams } from "src/router";

export const IdrDataRoute: FC<PropsWithChildren> = ({ children }) => {
  const { id } = useParams<{ id: string }>();
  const { isPermitted, isLoading } = useResourcePermission(
    {
      v2: {
        resource: "idr",
        grant: "can_access_data",
        id: id ?? "",
      },
    },
    { enabled: Boolean(id) },
  );

  if (isLoading) {
    return <PageContentSkeleton />;
  }

  if (!id) {
    return <Navigate to="/idr" replace />;
  }

  if (!isPermitted) {
    return <Navigate to={`/idr/${id}/summary`} replace />;
  }

  return children;
};
